import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rap-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() page: number;
  @Input() pageSize: number;
  @Input() collectionSize: number;
  @Output() onPageChange = new EventEmitter<number>();
  @Output() onPageSizeChange = new EventEmitter<number>();

  pageSizeOptions = [10, 25, 50, 100];

  get rangeStart(): number {
    return (this.page - 1) * this.pageSize + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.page * this.pageSize, this.collectionSize);
  }

  onPageSizeSelect(event: Event) {
    const newSize = +(event.target as HTMLSelectElement).value;
    this.onPageSizeChange.emit(newSize);
  }
}
